module.exports = __webpack_public_path__ + "static/apple_store_badge-5566d70281c8791f6a4be19cd81e3f1b.svg";